module.exports = __webpack_public_path__ + "img/a84d602.png";